module.exports = __webpack_public_path__ + "facc321280564a96a35c107d205598f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/moduleImg2.png
// module id = 1374
// module chunks = 0